import React from 'react';
import If from '../If';
import styled from 'styled-components';
import { MenuItem } from '#/modules/workOrder/utils/bulk-edit';
import { color } from '@nuvolo/nuux-theme/utils';
import FAIcon from '#/common/components/FAIcon';

const WIDTH = 286;
const MARGIN_TOP = 5;
const MARGIN_RIGHT = 30;

const PopupWrapper = styled.div<{
  top?: string | number;
  left?: string | number;
  bottom?: string | number;
  right?: string | number;
}>`
  position: absolute;
  top: ${({ top = 0 }) => (isNaN(Number(top)) ? top : `${Number(top) + MARGIN_TOP}px`)};
  left: ${({ left = 0 }) =>
    isNaN(Number(left)) ? left : `${Number(left) - WIDTH - MARGIN_RIGHT}px`};
  bottom: ${({ bottom = 0 }) => (isNaN(Number(bottom)) ? bottom : `${Number(bottom)}px`)};
  right: ${({ right = 0 }) => (isNaN(Number(right)) ? right : `${Number(right)}px`)};

  z-index: 9000;
  background: ${color('custom', 'invertedBackground')};
  width: ${WIDTH}px;
  height: fit-content;
  border: 1px solid ${color('primary', 'light3')};
  border-radius: 12px;
  padding: 8px 0;
  box-shadow: var(--elevation-lvl3);
  overflow: hidden;
`;

const Row = styled.div`
  height: 36px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: ${color('ui', 'light3')};
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
`;

type ToolbarButtonPopupProps = {
  top?: string | number;
  left?: string | number;
  right?: string | number;
  bottom?: string | number;
  visible: boolean;
  menuItems: MenuItem[];
  onClose: () => void;
  onSelected: (id: string, isEligible?: boolean) => void;
};

const ToolbarButtonPopup: React.FC<ToolbarButtonPopupProps> = ({
  top,
  left,
  right,
  bottom,
  visible,
  menuItems,
  onClose,
  onSelected,
}) => {
  return (
    <If condition={visible}>
      <PopupWrapper top={top} left={left} right={right} bottom={bottom}>
        {menuItems?.map(({ icon, label, id, isEligible }, index: number) => (
          <Row
            key={id}
            onClick={() => {
              onSelected(id, isEligible);
              onClose();
            }}>
            <div style={{ paddingRight: '8px' }}>
              <FAIcon icon={icon} size="sm" />
            </div>
            {label}
          </Row>
        ))}
      </PopupWrapper>

      <Overlay onClick={onClose} />
    </If>
  );
};

export default React.memo(ToolbarButtonPopup);
